import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22Playfair_Display%22,%22arguments%22:[{%22variable%22:%22--font-playfair%22,%22subsets%22:[%22latin%22],%22weight%22:[%22400%22,%22500%22,%22600%22,%22700%22],%22style%22:[%22normal%22,%22italic%22]}],%22variableName%22:%22playfair%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Playfair Display', 'Playfair Display Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
